import { useEffect, useRef, useState } from 'react';

// Seconds left and a (re)start function; restarting with the same value works, which a prop-driven hook would miss.
export const useCountdown = () => {
  const [ remaining, setRemaining ] = useState(0);
  const timer = useRef<ReturnType<typeof setInterval>>();

  const start = (seconds: number) => {
    clearInterval(timer.current);
    setRemaining(seconds);
    if (seconds <= 0) return;
    timer.current = setInterval(() => setRemaining((value) => {
      if (value <= 1) clearInterval(timer.current);
      return Math.max(0, value - 1);
    }), 1000);
  };

  useEffect(() => () => clearInterval(timer.current), []);

  return [ remaining, start ] as const;
};
